import React, { useContext } from "react";
import { languageKey } from "../../../constants/static";
import { nonDiscriminationNoticeURL } from "../../../constants/urls";
import { StateContext } from "../../../context/stateContext";
import { useFetch } from "../../../hooks/useFetch";
import { IURLAssetReference } from "../../../interfaces/urlAssetReference";
import { translations } from "../../../translate";
import utils from "../../../utils/helperFunction";
import ParentFragmentHTML from "../../lib/ParentFragmentHTML";
import LegalAndPrivacyContainer from "../legalAndPrivacyContainer/LegalAndPrivacyContainer";

const NonDiscriminationNotice = () => {
  const { cidmUrl, stateUSACode, languageCode } = useContext(StateContext);
  const { getStateName } = utils;
  const URL = `${cidmUrl}${nonDiscriminationNoticeURL(languageCode)}/${getStateName(
    stateUSACode
  )}&experience/language/${languageCode}&content/dam/hcsc/common/manage-my-account/unauthenticated-legal-and-privacy/${
    languageKey[languageCode]
  }/${getStateName(stateUSACode)}-general/registration/unauthenticated/non-discrimination-notice`;
  const response = useFetch<{ urlAssetReferences: IURLAssetReference[] }>(URL);
  const data = response.data?.urlAssetReferences ? response.data.urlAssetReferences : [];
  return (
    <LegalAndPrivacyContainer title={translations.NonDiscrimination[languageCode]}>
      <ParentFragmentHTML data={data} />
    </LegalAndPrivacyContainer>
  );
};

export default NonDiscriminationNotice;
